import { UI } from '../lib/ui.js'
export class Tabs {
    constructor(tabs){
        const ui = window.ui ? window.ui : new UI
        this.fragment = new DocumentFragment()
        this.tabs = ui.element('ul',{class:'nav nav-tabs'})
        this.fragment.append(this.tabs)
        this.content = ui.element('div',{class:'tab-content',role:'presentation'})
        this.fragment.append(this.content)
        this.tab = (label,id) => ui.element('li',{id:id,class:'nav-item'},
            ui.element('button',{class:'nav-link','data-bs-toggle':'tab'},label)
        )
        this.panel = (content,id) => ui.element('div',{id:id,class:'tab-pane fade',role:'tabpanel'},content)
        if(tabs)
            this.add(tabs)
        return this.fragment
    }
    /**
     * Creates Tabs from array with id, label and content property
     * @param {*} tabs 
     */
    add(tabs){
        tabs.forEach(item=>{
            this.tabs.append(this.tab(item.label,item.id))
            this.content.append(this.panel(item.content,item.id))
        })
    }
    remove(id){

    }
    replace(id, replacement){

    }
}